module.exports = __webpack_public_path__ + "img/672547706.847267be.jpg";